import React from 'react';
import { Form, Col} from 'react-bootstrap';
import {  getIn } from 'formik';
import InputDateFormat from '../InputDateFormat';
export default class BasicInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state ={
            focused:false
        }
    }
   
     render(){
        if(this.props.type === 'spouse' && this.props.stepsOpened <= 1){
                if(!this.props.values.spouse){
                    this.props.values.sposue={};
                }
                this.props.values.spouse.lastName = this.props.lastName || this.props.values.spouse.lastName;
        }
        return(
                <Form.Row>
                    <Form.Group as={Col} md="6" controlId="validationFormikname">
                        <Form.Label className="required">First Name</Form.Label>
                        <Form.Control
                                type="text"
                                value={getIn(this.props.values, `${this.props.type}.firstName`)}
                                onChange={e => {this.props.setFieldValue( `${this.props.type}.firstName`,e.target.value);
                                this.props.setFieldTouched( `${this.props.type}.firstName`,true);}}
                                isValid={getIn(this.props.touched, `${this.props.type}.firstName`) && !getIn(this.props.errors, `${this.props.type}.firstName`)}
                                isInvalid={getIn(this.props.errors, `${this.props.type}.firstName`) }
                                // className={
                                //     getIn(errors, `${type}.firstName`) 
                                //       ? 'text-input error'
                                //       : 'text-input'
                                //   }
                        />
                            {/* <ErrorMessage
                            component="div"
                            name="client.firstName"
                            className="input-feedback"
                            /> */}
                        <Form.Control.Feedback type="invalid">
                            { getIn(this.props.errors, `${this.props.type}.firstName`) }
                        </Form.Control.Feedback> 
                    </Form.Group>
                    <Form.Group as={Col} md="6" controlId="validationFormikname">
                        <Form.Label className="required">Last Name</Form.Label>
                        <Form.Control
                                type="text"
                                value={getIn(this.props.values, `${this.props.type}.lastName`)}
                                onChange={e => {
                                    this.props.setFieldValue( `${this.props.type}.lastName`,e.target.value);
                                this.props.setFieldTouched( `${this.props.type}.lastName`,true);
                                    this.props.setLastName(e.target.value)
                                }}
                                isValid={getIn(this.props.touched, `${this.props.type}.lastName`) && !getIn(this.props.errors, `${this.props.type}.lastName`)}
                                isInvalid={getIn(this.props.errors, `${this.props.type}.lastName`) }
                                // className={
                                //     getIn(errors, `${type}.lastName`) 
                                //       ? 'text-input error'
                                //       : 'text-input'
                                //   }
                        />
                            {/* <ErrorMessage
                            component="div"
                            name="client.lastName"
                            className="input-feedback"
                            /> */}
                        <Form.Control.Feedback type="invalid">
                            { getIn(this.props.errors, `${this.props.type}.lastName`) }
                        </Form.Control.Feedback> 
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationFormikBirthday">
                        <Form.Label className="required">Birthdate</Form.Label>
                        <InputDateFormat
                            inputvalue={getIn(this.props.values, `${this.props.type}.birthdate`) } 
                            name={`${this.props.type}.birthdate`}
                            placeholder={"mm/dd/yyyy"}
                            mindate={new Date(+new Date().getFullYear() - 99,0,1)}
                            maxdate={new Date()}
                            onValueChange={e => { 
                                if(e.value && e.value.length >= 8){
                                    this.props.setFieldValue( `${this.props.type}.birthdate`, e.formattedValue);
                                    this.props.setFieldTouched( `${this.props.type}.birthdate`,true);  
                                }
                                }
                            }
                            error={getIn(this.props.errors, `${this.props.type}.birthdate`) }
                            />
                            
                        {/* <DatePicker
                               allowPast={true}
                               allowFuture={false}
                                // clearIcon={null}
                                // onBlur={e => {  let val =e.target.value; 
                                //     console.log('blur called',e.target.value);
                                //     if(!val && val != 0 )
                                //         return;
                                //     if(parseInt(val) === 0 && val.toString().length ){

                                //     }
                                //     let month = limit(val.substring(0, 2), '12');
                                // }}
                                onChange={e => console.log('onchange',e)}
                                handleChange={e => {
                                    // let d = ApplicationHelpers.formatDate(e);
                                    // console.log('change',e,d);
                                    // if(!d){
                                    //     this.props.setFieldValue(`${this.props.type}.birthdate`, '');
                                    //     return;
                                    // } 
                                    this.props.setFieldValue(`${this.props.type}.birthdate`, e);this.props.setFieldTouched(`${this.props.type}.birthdate`,true);} }
                                error={getIn(this.props.errors, `${this.props.type}.birthdate`) }
                                value={getIn(this.props.values, `${this.props.type}.birthdate`) }
                                touched={this.props.setFieldTouched }
                                /> */}
                    </Form.Group>
                </Form.Row>
        );
    }
}